import { inject } from "vue";
import { API_SYMBOL } from "../injection-symbols";
import type { MonitoringApi } from "../monitoring-api";

export function useApi(): MonitoringApi {
	const api = inject(API_SYMBOL);
	if (!api) throw new Error("Api not found on the app instance");

	return api;
}
